var SharedFeatureFlagModel;

SharedFeatureFlagModel = (function() {
  function SharedFeatureFlagModel() {}

  SharedFeatureFlagModel.prototype.isEnabled = function(key) {
    var ref;
    return window.evaluate((ref = window.featureFlagJSON) != null ? ref[key] : void 0);
  };

  SharedFeatureFlagModel.prototype.isRedesignOrdersUSEnabled = function() {
    return this.isEnabled("redesignOrdersUS");
  };

  SharedFeatureFlagModel.prototype.isShowLiveChatEnabled = function() {
    return this.isEnabled("showLiveChat");
  };

  SharedFeatureFlagModel.prototype.isShowMerchantInfoFieldsEnabled = function() {
    return this.isEnabled("showMerchantInfoFields");
  };

  SharedFeatureFlagModel.prototype.isShowUserContactInfoFieldsEnabled = function() {
    return this.isEnabled("showUserContactInfoFields");
  };

  SharedFeatureFlagModel.prototype.isSearchBasedDropDownsEnabled = function() {
    return this.isEnabled("searchBasedDropDowns");
  };

  SharedFeatureFlagModel.prototype.isRecaptchaEnabled = function() {
    return this.isEnabled("recaptchaEnabled");
  };

  SharedFeatureFlagModel.prototype.isShowFlexibleFormsForUSEnabled = function() {
    return this.isEnabled("showFlexibleFormsForUS");
  };

  return SharedFeatureFlagModel;

})();

module.exports = SharedFeatureFlagModel;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3NoYXJlZC9mcm9udGVuZC9tb2RlbHMvZmVhdHVyZV9mbGFnX21vZGVsLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zaGFyZWQvZnJvbnRlbmQvbW9kZWxzL2ZlYXR1cmVfZmxhZ19tb2RlbC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBTTs7O21DQUVKLFNBQUEsR0FBVyxTQUFDLEdBQUQ7QUFDVCxRQUFBO1dBQUEsTUFBTSxDQUFDLFFBQVAsNkNBQXdDLENBQUEsR0FBQSxVQUF4QztFQURTOzttQ0FHWCx5QkFBQSxHQUEyQixTQUFBO1dBQ3pCLElBQUMsQ0FBQSxTQUFELENBQVcsa0JBQVg7RUFEeUI7O21DQUczQixxQkFBQSxHQUF1QixTQUFBO1dBQ3JCLElBQUMsQ0FBQSxTQUFELENBQVcsY0FBWDtFQURxQjs7bUNBR3ZCLCtCQUFBLEdBQWlDLFNBQUE7V0FDL0IsSUFBQyxDQUFBLFNBQUQsQ0FBVyx3QkFBWDtFQUQrQjs7bUNBR2pDLGtDQUFBLEdBQW9DLFNBQUE7V0FDbEMsSUFBQyxDQUFBLFNBQUQsQ0FBVywyQkFBWDtFQURrQzs7bUNBR3BDLDZCQUFBLEdBQStCLFNBQUE7V0FDN0IsSUFBQyxDQUFBLFNBQUQsQ0FBVyxzQkFBWDtFQUQ2Qjs7bUNBRy9CLGtCQUFBLEdBQW9CLFNBQUE7V0FDbEIsSUFBQyxDQUFBLFNBQUQsQ0FBVyxrQkFBWDtFQURrQjs7bUNBR3BCLCtCQUFBLEdBQWlDLFNBQUE7V0FDL0IsSUFBQyxDQUFBLFNBQUQsQ0FBVyx3QkFBWDtFQUQrQjs7Ozs7O0FBR25DLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
